import { AdyenCheckout, Dropin, Card } from "@adyen/adyen-web";
import Route from "../route";
import _ from "lodash";
import highlightTermsAndConditions from "./terms_and_conditions";

function disableCard(storedPaymentMethodId) {
    axios
        .post("/payment/disablepaymentcard", {
            storedPaymentMethodId: storedPaymentMethodId,
        })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            console.log(error);
        });
}

function setAdyenStatusToError(dropin, msg = null) {
    dropin.setStatus("error", {
        message: msg ?? " ",
    });
}

export async function dropIn(successCallback, failCallback, adyenPaymentUrl = "/payment/adyenpayment", adyenConfig = {}) {
    var env = $(".adyen").data("ae");
    var clientKey = $(".adyen").data("ck");
    var id = $(".adyen").data("id");
    var sessionData = $(".adyen").data("sd");

    const configuration = {
        environment: env,
        clientKey: clientKey,
        analytics: {
            enabled: true,
        },
        session: {
            id: id,
            sessionData: sessionData,
        },
        onSubmit: (state, dropin) => {
            if ($('#accept_terms').length && !$('#accept_terms').is(':checked')) {
                highlightTermsAndConditions();
                dropin.setStatus("ready");
                return;
            } else {
                state.data.forceFailPayment = $("#adyenFailTest").is(":checked");
                state.data.paymentRoute = Route;
                axios
                    .post(adyenPaymentUrl, state.data)
                    .then((response) => {

                        if (response.data.action) {
                            dropin.handleAction(response.data.action);
                        } else {
                            if (response.data.success === true) {
                                var reference = response.data.reference;
                                successCallback(reference);
                            } else {
                                setAdyenStatusToError(dropin);
                                failCallback(response.data.errCode);
                            }
                        }
                    })
                    .catch(() => {
                        setAdyenStatusToError(dropin);
                        failCallback();
                    });
            }

        },
        onAdditionalDetails: (state, dropin) => {
            axios
                .post("/account/saved-cards/paymentdetails", state)
                .then((response) => {
                    if (response.action) {
                        dropin.handleAction(response.action);
                    } else {
                        dropin.setStatus("success", { message: "Card Saved" });
                        window.location.href = "/account";
                    }
                })
                .catch(() => {
                    setAdyenStatusToError(dropin, "There was a problem. Please check details and try again, or use a different card");
                    location.reload();
                });
        },
    };

    const checkout = await AdyenCheckout(configuration);

    const dropinConfiguration = {
        paymentMethodComponents: [Card],
        showStoredPaymentMethods: true,
        showRemovePaymentMethodButton: (adyenConfig.hasOwnProperty("showRemovePaymentMethodButton") ? adyenConfig.showRemovePaymentMethodButton : true),
        onDisableStoredPaymentMethod(
            storedPaymentMethodId,
            resolve,
            reject
        ) {
            disableCard(storedPaymentMethodId);
            resolve();
        },
        onReady: () => {
            $('#dropin-container').addClass('ready');
        },
        instantPaymentTypes: ['applepay', 'googlepay'],
        paymentMethodsConfiguration: {
            card: {
                hasHolderName: true,
                holderNameRequired: true,
                enableStoreDetails: (adyenConfig.hasOwnProperty("enableStoreDetails") ? adyenConfig.enableStoreDetails : true),
                name: "Credit or debit card",
                onLoad: () => {
                    if (adyenConfig.hasOwnProperty("enableStoreDetails") && !adyenConfig.enableStoreDetails) {
                        $("#dropin-container .adyen-checkout__store-details").hide();
                    }
                },
                onError: () => {}
            },
            wechatpayQR: {
                onSubmit: false,
            },
            alipay: {
                onSubmit: false,
            },
        }
    };

    let dropinComponent;

    if ($('#dropin-container').length) {
        dropinComponent = new Dropin(checkout, dropinConfiguration).mount('#dropin-container');
    }

    $(document).on("click", ".reload", function () {
        if (dropinComponent !== undefined) {
            dropinComponent.setStatus("ready");
        }
    });

    $(document).on("change", 'input[name="accept_terms"]', function () {
        if ($(this).is(":checked")) {
            if (dropinComponent !== undefined) {
                dropinComponent.setStatus("ready");
                $('.adyen-checkout__button--pay').removeClass('disabled');
            }
            $(".acceptTermsMessage").addClass("d-none");
        }
    });
}
